import React from "react";
import classNames from "classnames/bind";
import styles from "../../AddJobModal.module.scss";
import BaseAddressInput from "~/components/common/base-address-input/BaseAddressInput";
import { AddressSuggestion } from "../../types/add-job.types";

const cx = classNames.bind(styles);

interface JobAddressInputProps {
  value: string;
  customerAddress?: string;
  useCustomerAddress?: boolean;
  onChange: (value: string) => void;
  onSuggestionSelect: (suggestion: AddressSuggestion) => void;
  onUseCustomerAddressChange?: (checked: boolean) => void;
}

const JobAddressInput: React.FC<JobAddressInputProps> = ({
  value,
  customerAddress,
  useCustomerAddress = false,
  onChange,
  onSuggestionSelect,
  onUseCustomerAddressChange,
}) => {
  return (
    <>
      <BaseAddressInput
        value={value}
        onChange={onChange}
        onSuggestionSelect={onSuggestionSelect}
        placeholder="Search for area, street name, locality..."
        label="Job Address"
      />
      {customerAddress && (
        <div className={cx("checkbox-container", "mt-[20px]")}>
          <input
            type="checkbox"
            checked={useCustomerAddress}
            onChange={(e) => {
              if (onUseCustomerAddressChange) {
                onUseCustomerAddressChange(e.target.checked);
              }
            }}
            className={cx("checkbox")}
          />
          <label className={cx("checkbox-label")}>Use Customer Address</label>
        </div>
      )}
    </>
  );
};

export default JobAddressInput;
